import React from "react";
import { Footer } from "./Footer";
import { useOpenHours } from "../../../lib/useOpenHours";
import { useFooter } from "../../../lib/useFooter";

interface Props {}

const FooterContainer: React.FC<Props> = () => {
  const hoursData = useOpenHours();
  const libraryHours =
    hoursData?.kontentItemDataHoursOfOperation?.elements?.open_hours.filter(
      (data) => data.hours
    );
  const footerData = useFooter();

  return <Footer libraryHours={libraryHours} footerData={footerData}></Footer>;
};

export default FooterContainer;
